var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 634,
    height: 299,
    viewBox: "0 0 634 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M270.835 120.638H201.69L223.835 66.6381C130.835 59.138 84.8353 70.6378 69.8353 138.638C61.8341 189.138 105.335 233.638 153.835 233.638L175.835 180.638H246.335L206.335 277.638C198.061 294.637 192.527 298.095 181.835 298.638H135.335C12.3347 283.138 -62.6652 104.638 86.3347 17.1378C118.335 -1.65409 160.71 -1.61278 276.835 1.6378C291.835 2.05768 311.335 24.1376 303.335 46.1376L270.835 120.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.194 248.571C379.194 207.071 421.694 193.071 511.694 193.071L516.694 172.571C520.694 151.071 508.588 145.943 485.694 143.071C437.694 141.071 368.082 162.803 338.694 183.071C324.194 193.071 307.194 218.071 305.194 248.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.194 115.067H614.194C623.194 113.071 632.595 96.8993 629.694 79.5708C624.194 63.5708 609.194 50.0674 592.194 50.0674H404.694C396.194 50.0674 379.194 57.0674 373.194 68.5674L355.194 115.067Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfLogo);
export default __webpack_public_path__ + "static/media/CFLogo.9e92ac4b51b2bdfa8a52ff8bc1102654.svg";
export { ForwardRef as ReactComponent };